import { render, staticRenderFns } from "./ClasificatieCheck.vue?vue&type=template&id=4f410fe0"
import script from "./ClasificatieCheck.vue?vue&type=script&lang=js"
export * from "./ClasificatieCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports